import FeaturePageTemplate from "@/components/FeaturePageTemplate";

export default function AiWtcPage() {
  return (
    <FeaturePageTemplate
      slug="wtc"
      accent="#2563EB"
      badge="Approved brain · Always current"
      title="WebsiteTech Center"
      tagline="The approved brain behind every AI reply"
      subtitle="Your business's single source of truth. Business profile, knowledge center with versioning + expiry + approval workflow, gap detector for unanswered questions, integrations, and usage meters. Everything the AI says is grounded here — with citations and a hallucination score."
      primaryCta={{ label: "Open the Center", to: "/wtc" }}
      secondaryCta={{ label: "Configure your rep", to: "/representative" }}
      brandStripe="No hallucinations. Every reply cites the source article and its last-reviewed date."
      flow={[
        { n: "1", title: "Import",   desc: "Website crawl + document upload + FAQ paste." },
        { n: "2", title: "Approve",  desc: "Draft → in-review → approved. Every version snapshot kept." },
        { n: "3", title: "Ground",   desc: "Reps only cite approved articles. Expired articles auto-flag." },
        { n: "4", title: "Detect gaps", desc: "Questions the AI can't answer surface as a queue." },
        { n: "5", title: "Improve",  desc: "Approve a gap fix → knowledge updated → next visitor benefits." },
      ]}
      capabilities={[
        { icon: "BookOpen",  title: "Knowledge Center",     desc: "Versioning, expiry dates, approval workflow, visibility control (public/internal/private)." },
        { icon: "Building2", title: "Business profile",     desc: "Brand voice, policies, service area, opening hours, contact channels." },
        { icon: "Search",    title: "Gap detector",         desc: "Every unanswered question queues as a knowledge gap. Fix once, benefit forever." },
        { icon: "Globe",     title: "Auto ingest",          desc: "One-click crawl of your website, PDFs, and text documents. Re-crawl on a schedule." },
        { icon: "Plug",      title: "Integrations",         desc: "Google Business Profile, calendars, review sites, CRMs, payments — all pluggable." },
        { icon: "Gauge",     title: "Usage meters",         desc: "Track tokens, calls, storage per representative and per period." },
      ]}
      safetyBullets={[
        ["Approval workflow", "No knowledge article goes live without a designated approver."],
        ["Expiry dates",      "Pricing, hours, and seasonal offers auto-expire — never stale."],
        ["Version snapshots", "Rollback to any prior version with one click."],
        ["Visibility control","Public / internal / private per article; representatives only see what they're allowed to."],
      ]}
      closingHeadline="Give your AI a brain worth trusting."
      closingSubtitle="Approved, versioned, dated, and cited — every answer traceable to its source."
      testIdPrefix="ai-wtc-page"
    />
  );
}
